import { orderXClient } from '@/service/client'
import { TradeList } from '@/types/generated/common/trading'
import { HistoryRequest, ServerMessage, UnifiedOrderList } from '@/types/generated/public_api'
import type { ErrorResponse } from '@/types/service'

export interface FetchHistoryParams {
  accountId: string
  symbols?: string[]
  currency?: string[]
  from?: string
  to?: string
  limit?: number
}

/**
 * Fetch order history via API
 * Uses orderHistory field in ApiRequest
 * Response comes in DataPayload.unifiedOrders
 */
export async function fetchOrderHistory(params: HistoryRequest): Promise<UnifiedOrderList> {
  try {
    const { data } = await orderXClient.post<ServerMessage>('/api', { orderHistory: params })
    if (!data.data?.unifiedOrders) {
      return { items: [] }
    }
    return data.data.unifiedOrders
  } catch (e) {
    const error = e as ErrorResponse
    return Promise.reject(error)
  }
}

/**
 * Fetch trade history via API
 * Uses tradeHistory field in ApiRequest
 * Response comes in DataPayload.trades
 */
export async function fetchTradeHistory(params: HistoryRequest): Promise<TradeList> {
  try {
    const { data } = await orderXClient.post<ServerMessage>('/api', { tradeHistory: params })

    if (!data.data?.trades) {
      return { trades: [] }
    }
    return data.data.trades
  } catch (e) {
    const error = e as ErrorResponse
    return Promise.reject(error)
  }
}
